/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Enock Gomes Neto",
  title: "Hi all, I'm Enock",
  subTitle: emoji("I am an Embedded Software Engineer with over 10 years of experience working with Linux-based embedded systems and Android. 🚀"),
  resumeLink: require("./assets/docs/EnockGomesNeto.pdf"), // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/enocknt",
  linkedin: "https://www.linkedin.com/in/enocknt",
  gmail: "enocknt@gmail.com",
  gitlab: "https://gitlab.com/enocknt",
  facebook: "https://www.facebook.com/enocknt",
  instagram: "https://www.instagram.com/enocknt",
  stackoverflow: "https://stackoverflow.com/users/5781266/enock-gomes-neto",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "Full Stack Web Developer 🌐, App Developer 📱, ML Engineer 🤖 and Embedded Developer 📺",
  skills: [
    emoji("⚡ Over 10 years of experience in embedded systems, full-stack web development, desktop applications, AI, multimedia frameworks/formats, etc."),
    emoji("⚡ Proficient in using and managing Unix-like systems (Ubuntu, Arch Linux, Debian)."),
    emoji("⚡ Comfortable with common CLI tools, shell/scripts/commands syntax, SSH, rsync/scp, etc."),
    emoji("⚡ Experienced with best practices (proficient in version control with Git and SVN, configuring and using static and dynamic code analysis tools, continuous integration, automated testing, etc)."),
    emoji("⚡ Experienced with the use of agile methodologies (Scrum)."),
    emoji("⚡ Front-end: HTML5, CSS3, JavaScript/TypeScript (jQuery, React, Vanilla)."),
    emoji("⚡ Back-end: Node (Express), Python (FastAPI, Flask, Django), Spring, C/C++, PHP, C#, Delphi/Object Pascal."),
    emoji("⚡ Relational (SQlite, MariaDB, MySQL, PostgreSQL) and non-relational (MongoDB) databases."),
    emoji("⚡ Container, virtualization and orchestration technologies (Docker, Kubernetes)."),
    emoji("⚡ Programming of embedded systems (Android and Linux) and IoT (ESP8266, ESP32, Raspberry)."),
    emoji("⚡ Data Science (Pandas, NumPy, Matplotlib), Deep Learning and Artificial Intelligence (Keras, PyTorch)."),
    emoji("⚡ Multimedia frameworks/tools (GStreamer, FFmpeg, GPAC/MP4Box, Bento4, Shaka)."),
    emoji("⚡ Mobile development with the Android platform (Java, NDK, AndroidStudio, Gradle)."),
    emoji("⚡ Experience with using, fixing bugs and implementing new features in several open source projects (Android, WebKit, GStreamer, DirectFB).")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "Bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "Android",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "git-scm",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "GitLab",
      fontAwesomeClassname: "fab fa-gitlab"
    },
    {
      skillName: "Figma",
      fontAwesomeClassname: "fab fa-figma"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "PHP",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "Ubuntu",
      fontAwesomeClassname: "fab fa-ubuntu"
    },
    {
      skillName: "Windows",
      fontAwesomeClassname: "fab fa-windows"
    },
    {
      skillName: "Terminal",
      fontAwesomeClassname: "fas fa-terminal"
    },
    {
      skillName: "Linux",
      fontAwesomeClassname: "fab fa-linux"
    },
    {
      skillName: "Chrome",
      fontAwesomeClassname: "fab fa-chrome"
    },
    {
      skillName: "Raspberry",
      fontAwesomeClassname: "fab fa-raspberry-pi"
    },
    {
      skillName: "Discord",
      fontAwesomeClassname: "fab fa-discord"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Descomplica Digital College",
      logo: require("./assets/images/descomplicaLogo.png"),
      subHeader: "Postgraduate Degree – Program Analysis and Development",
      duration: "January 2022 – July 2023",
      desc: "Faculdade Descomplica is a private Brazilian higher education institution, founded in 2017. It stands out for offering distance learning undergraduate courses, with an innovative pedagogical proposal that aims to prepare qualified professionals for the job market.",
      descBullets: []
    },
    {
      schoolName: "Descomplica Digital College",
      logo: require("./assets/images/descomplicaLogo.png"),
      subHeader: "Postgraduate Degree – Multiplatform Mobile Application Projects",
      duration: "January 2022 – January 2023",
      desc: "Faculdade Descomplica is a private Brazilian higher education institution, founded in 2017. It stands out for offering distance learning undergraduate courses, with an innovative pedagogical proposal that aims to prepare qualified professionals for the job market.",
      descBullets: []
    },
    {
      schoolName: "Federal University of Rio Grande do Norte",
      logo: require("./assets/images/ufrnLogo.png"),
      subHeader: "Interdisciplinary Bachelor's Degree – Science and Technology",
      duration: "January 2018 – November 2021",
      desc: "The Federal University of Rio Grande do Norte (UFRN) is a public higher education institution located in Natal, capital of the state of Rio Grande do Norte, in Brazil. Founded in 1958, it is one of the largest and most important universities in the Brazilian Northeast.",
      descBullets: []
    },
    {
      schoolName: "Estácio de Sá University",
      logo: require("./assets/images/estacioLogo.png"),
      subHeader: "Associate Degree – Systems Analysis and Development",
      duration: "July 2019 – August 2021",
      desc: "Estácio is one of the largest private higher education institutions in Brazil, offering a wide variety of undergraduate, postgraduate, technical and extension courses in different areas of knowledge. Founded in 1970, the institution has units in different regions of the country, serving thousands of students.",
      descBullets: []
    },
    {
      schoolName: "Federal Institute of Education, Science and Technology of Rio Grande do Norte",
      logo: require("./assets/images/ifrnLogo.png"),
      subHeader: "Integrated Middle Level Technical Course – Computing",
      duration: "January 2008 – July 2011",
      desc: "The Federal Institute of Education, Science and Technology of Rio Grande do Norte (IFRN) is a Brazilian public institution of technical, technological and higher education. Founded in 1909 as a School for Artifices Apprentices, IFRN went through several transformations over time until it became a federal institute in 2008.",
      descBullets: []
    },
    {
      schoolName: "Digital Metropole Institute - Federal University of Rio Grande do Norte",
      logo: require("./assets/images/imdLogo.png"),
      subHeader: "Programmers Training Course – Web Programming",
      duration: "January 2010 – January 2011",
      desc: "The Digital Metropole Institute (IMD) is an academic unit of the Federal University of Rio Grande do Norte (UFRN) located in Natal, Rio Grande do Norte, Brazil. Founded in 2009, IMD's main mission is to develop research, teaching and innovation in information and communication technologies (ICT).",
      descBullets: []
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Front-end", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Back-end",
      progressPercentage: "80%"
    },
    {
      Stack: "Mobile",
      progressPercentage: "80%"
    },
    {
      Stack: "Embedded",
      progressPercentage: "95%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Master Software Engineer",
      company: "MoPA Embedded Systems",
      companylogo: require("./assets/images/mopaLogo.png"),
      date: "August 2021 – Present",
      desc: "Company dedicated to the development and supply of embedded systems. Headquartered in Natal – RN, the company focuses on creating customized hardware and software solutions for various sectors, including industrial automation, embedded electronics, medical devices, Internet of Things (IoT) and much more.",
      descBullets: [
        "Development of the payment system (Pix Saque and Boletos) for SmartPOS devices (Intelligent Point of Sale).",
        "Development of the Brazilian Digital TV Forum (SBTVD) Test Suite to validate Ginga DTV Play.",
        "Development of Ginga DTV Play – New version of the Ginga middleware, which encompasses the Ginga-NCL, Ginga-CCWS and Ginga-HTML5 subsystems.",
        "Development of Ginga-CCWS (ABNT NBR 15606-11) – Ginga middleware subsystem responsible for executing second screen applications and managing information on broadcast channels.",
        "Development of Ginga-HTML5 (ABNT NBR 15606-10) – Ginga middleware subsystem responsible for executing HTML5 applications.",
        "Development of Ginga-NCL (ABNT NBR 15606-2) – Open specification middleware adopted by the Japanese-Brazilian Digital Terrestrial TV System (ISDB-T) for set-top boxes, televisions and portable devices, in order to offer interactivity to Digital TV users."
      ]
    },
    {
      role: "Senior Software Engineer",
      company: "MoPA Embedded Systems",
      companylogo: require("./assets/images/mopaLogo.png"),
      date: "January 2019 – July 2021",
      desc: "Company dedicated to the development and supply of embedded systems. Headquartered in Natal – RN, the company focuses on creating customized hardware and software solutions for various sectors, including industrial automation, embedded electronics, medical devices, Internet of Things (IoT) and much more.",
      descBullets: [
        "Development of the Brazilian Digital TV Forum (SBTVD) Test Suite to validate Ginga DTV Play.",
        "Development of Ginga DTV Play – New version of the Ginga middleware, which encompasses the Ginga-NCL, Ginga-CCWS and Ginga-HTML5 subsystems.",
        "Development of Ginga-CCWS (ABNT NBR 15606-11) – Ginga middleware subsystem responsible for executing second screen applications and managing information on broadcast channels.",
        "Development of Ginga-HTML5 (ABNT NBR 15606-10) – Ginga middleware subsystem responsible for executing HTML5 applications.",
        "Development of Ginga-NCL (ABNT NBR 15606-2) – Open specification middleware adopted by the Japanese-Brazilian Digital Terrestrial TV System (ISDB-T) for set-top boxes, televisions and portable devices, in order to offer interactivity to Digital TV users."
      ]
    },
    {
      role: "Full Software Engineer",
      company: "MoPA Embedded Systems",
      companylogo: require("./assets/images/mopaLogo.png"),
      date: "June 2016 – December 2018",
      desc: "Company dedicated to the development and supply of embedded systems. Headquartered in Natal – RN, the company focuses on creating customized hardware and software solutions for various sectors, including industrial automation, embedded electronics, medical devices, Internet of Things (IoT) and much more.",
      descBullets: [
        "Development of Ginga-NCL (ABNT NBR 15606-2) – Open specification middleware adopted by the Japanese-Brazilian Digital Terrestrial TV System (ISDB-T) for set-top boxes, televisions and portable devices, in order to offer interactivity to Digital TV users.",
        "Development of Zapper – Linux-based operating system to control and manage set-top box devices."
      ]
    },
    {
      role: "Junior Software Engineer",
      company: "MoPA Embedded Systems",
      companylogo: require("./assets/images/mopaLogo.png"),
      date: "January 2014 – May 2016",
      desc: "Company dedicated to the development and supply of embedded systems. Headquartered in Natal – RN, the company focuses on creating customized hardware and software solutions for various sectors, including industrial automation, embedded electronics, medical devices, Internet of Things (IoT) and much more.",
      descBullets: [
        "Development of Ginga-NCL (ABNT NBR 15606-2) – Open specification middleware adopted by the Japanese-Brazilian Digital Terrestrial TV System (ISDB-T) for set-top boxes, televisions and portable devices, in order to offer interactivity to Digital TV users.",
        "Development of Zapper – Linux-based operating system to control and manage set-top box devices.",
        "Development of TSRecorder – Tool for recording broadcast channel streams."
      ]
    },
    {
      role: "Software Development Intern",
      company: "MoPA Embedded Systems",
      companylogo: require("./assets/images/mopaLogo.png"),
      date: "May 2013 – December 2013",
      desc: "Company dedicated to the development and supply of embedded systems. Headquartered in Natal – RN, the company focuses on creating customized hardware and software solutions for various sectors, including industrial automation, embedded electronics, medical devices, Internet of Things (IoT) and much more.",
      descBullets: [
        "Development of ICD Platform Extension Software (ICDi) – Interactive Digital TV Program Management Platform for Ginga Middleware.",
        "Maintenance of the Digital Content Exchange Platform (ICD) – Platform developed by the National Education and Research Network (RNP) that allows the organization and exchange of local content on a network, increasing the supply and quality of content on TV channels and public and university radio stations."
      ]
    },
    {
      role: "Web Developer",
      company: "Suisse Color",
      companylogo: require("./assets/images/suisseLogo.png"),
      date: "June 2012 – May 2013",
      desc: "Company that has been operating in the Photographic Articles and Equipment market for over 20 years.",
      descBullets: [
        "Development of the Área Profissional Suisse Color – Online photo management system for professional photographers who partner with the company.",
        "Development of Impressão On-line Suisse Color – The company's online photo development system."
      ]
    },
    {
      role: "Web Developer",
      company: "RMB Informática",
      companylogo: require("./assets/images/rmbLogo.png"),
      date: "July 2011 – June 2012",
      desc: "Company that has been operating in the Information Technology (IT) market since 2003, providing services related to computer networks, internet hosting, software development, information security and marketing of IT products.",
      descBullets: [
        "Development of customized solutions for partner companies.",
        "Development of the company's Enterprise Resource Planning (ERP)."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+5584988490880",
  email_address: "enocknt@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "enocknt", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
